<template>
	<div class="knd-uitspraak">
		<div class="knd-paragraaf">
      <h3>Kies het juiste antwoord</h3>
      <slot name="media"></slot>

      <blockquote class="knd-quote">
        {{data.uitspraak}}       
         <footer> {{data.bron}}</footer>
      </blockquote>

      <Stelling 
        style="--stelling-color: #000"
        :correct-answer="question.antwoord" 
        :answer="answer"
        :id="question.id"
        :on-click="onClickUitspraak" 
        class="m-b-xl" 
      />

        <Uitklap 
          :collapse="answer.answered"
          :correct="answer.correct"
          :feedback="data.feedback"
          :url="data.url"
        />

		</div>
	</div>
</template>

<script>
import Uitklap from '@/components/uitklap';
import Stelling from '@/components/stelling';


let opties= [
  {
    label: 'ja',
    image: 'ja.png',
    value: 1,
  },
  {
    label: 'niet te zeggen',
    image: 'niet-te-zeggen.png',
    value: 2,
  },
  {
    label: 'nee',
    image: 'nee.png',
    value: 0,
  },  
]

export default {
	name: 'App',
  components: {Uitklap, Stelling},
  props: {
    data: Object,
    answer: Object,
    question: Object
  },
	data() {
		return {
      opties: opties,
      answered: false,
      correct: undefined
		}
	},
	methods: {
    getImage(name) {
      return require('@/assets/icons/' + name);
    },

    onClickUitspraak(payload) {
      this.answered = true;
      this.$store.dispatch('saveAnswer', 
      {
        id: this.data.id, 
        value: payload.value, 
        correct: payload.correct,
        answered: true 
      });
    }
	}
}
</script>


<style lang="scss">

.knd-quote {
  footer {
    text-align: right;
    font-weight: normal;
    font-family: $font-body;
    font-size: 1.4rem;
  }
}

.knd-uitspraak {
  background: #28006D;
  color: #FFF;

  .question-label {
    color: #000;
  }
}

</style>